var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCondominium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C5 2.44772 5.44772 2 6 2H18C18.5523 2 19 2.44772 19 3V8L21.3162 8.77208C21.7246 8.90819 22 9.29033 22 9.72076V21.25C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25V9.72076C2 9.29033 2.27543 8.90819 2.68377 8.77208L5 8V3ZM9 21.25H15V19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19V21.25ZM8 4C7.44772 4 7 4.44772 7 5V7C7 7.55228 7.44772 8 8 8H10C10.5523 8 11 7.55228 11 7V5C11 4.44772 10.5523 4 10 4H8ZM7 11V13C7 13.5523 7.44772 14 8 14H10C10.5523 14 11 13.5523 11 13V11C11 10.4477 10.5523 10 10 10H8C7.44772 10 7 10.4477 7 11ZM14 4C13.4477 4 13 4.44772 13 5V7C13 7.55228 13.4477 8 14 8H16C16.5523 8 17 7.55228 17 7V5C17 4.44772 16.5523 4 16 4H14ZM13 11V13C13 13.5523 13.4477 14 14 14H16C16.5523 14 17 13.5523 17 13V11C17 10.4477 16.5523 10 16 10H14C13.4477 10 13 10.4477 13 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondominium);
export default __webpack_public_path__ + "static/media/condominium.e0bad54ed07301c1d1e0ddf2b95f3e67.svg";
export { ForwardRef as ReactComponent };